import {
	createRef,
	useCallback,
} from "react"
import {Box} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {
	getCurrentScrollPosition,
	selectCurrentViewKey,
	setWorkspaceScrollPosition
} from "../../reducers/WorkspacePanelScrollSlice"
import {
	selectCurrentWorkspaceSearchIndex,
} from "../../reducers/workspaceSearchSlice"
import {useScrollPersistence} from "../../utils/usePersistScrollPosition"
import {useWorkspaceContext} from "../../pages/Dashboard"

const scrollRef = createRef()

export const WorkspacePanelScrollControlPanel = (props) => {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const currentWorkspaceSearchIndex = useSelector((state) => selectCurrentWorkspaceSearchIndex(state, workspaceId))
	const currentViewKey = useSelector((state) => selectCurrentViewKey(state, workspaceId))
	const scrollPositionOfCurrentPanel = useSelector((state) => getCurrentScrollPosition(state, workspaceId))
	const handleSetPosition = useCallback((ratio) => dispatch(setWorkspaceScrollPosition({newPosition: ratio, workspaceId})), [dispatch, workspaceId])

	useScrollPersistence(scrollRef.current, {
		savedPosition: scrollPositionOfCurrentPanel,
		setPosition: handleSetPosition,//(ratio) => dispatch(setWorkspaceScrollPosition({newPosition: ratio, workspaceId})),
		isActive: true,
		restoreDeps: [currentViewKey, currentWorkspaceSearchIndex],
		restoreConditional: !!currentViewKey
	})

	return (
		<Box
			id="note-panel-scroll"
			ref={ scrollRef }
			sx={{
				padding: "8px 0 8px 8px",
				overflowY: "scroll",
				flex: "1 1 100%"
			}}
		>
			{props.children}
		</Box>
	)
}